import debounce from 'lodash/debounce'

import { onDocumentEvent } from '@app/utils/domHelpers'
import { onNextPageTeardown } from '@app/adapters/page-teardown'

class SilverfinCarousel {
  constructor(container) {
    this.container = container

    this.viewPort = this.container.querySelector('[data-behaviour="viewport"]')
    this.slider = this.container.querySelector('[data-behaviour="slider"]')
    this.next = this.container.querySelector('[data-behaviour="next"]')
    this.prev = this.container.querySelector('[data-behaviour="prev"]')

    this.currentSlide = 0
    this.currentSliderLeft = 0
    this.eventListenersToRemove = []
    this.animationFrame = null
    this.slideIndex = 0

    this.update = this.update.bind(this)
    this.debouncedResize = debounce(this.update, 200)
    this.handleNextClick = this.handleNextClick.bind(this)
    this.handlePreviousClick = this.handlePreviousClick.bind(this)
    this.updateNavArrows = this.updateNavArrows.bind(this)
    this.removeEvents = this.removeEvents.bind(this)

    this.update()
    this.move(this.currentSlide)

    this.attachEvents()
  }

  attachEvents() {
    this.eventListenersToRemove = [
      onDocumentEvent(this.slider, 'update', null, this.update),
      onDocumentEvent(this.prev, 'click', null, this.handlePreviousClick),
      onDocumentEvent(this.next, 'click', null, this.handleNextClick),
      onDocumentEvent(window, 'resize', null, this.debouncedResize),
      onNextPageTeardown(this.removeEvents),
    ]
  }

  removeEvents() {
    this.eventListenersToRemove.forEach((removeListener) => {
      removeListener()
    })
  }

  update() {
    this.slides = this.slider.querySelectorAll('[data-behaviour="slide"]')
    this.slidesTotal = this.slides.length
    return this.updateNavArrows()
  }

  handleNextClick(e) {
    e.preventDefault()
    if (!this.next.classList.contains('disabled')) {
      return this.move(++this.slideIndex)
    }
  }

  handlePreviousClick(e) {
    e.preventDefault()
    if (!this.prev.classList.contains('disabled')) {
      return this.move(--this.slideIndex)
    }
  }

  home() {
    this.slideIndex = 0
    this.move(0)
    return this.update()
  }

  move(index) {
    if (index < 0 || index > this.slides.length - 1) {
      return null
    }

    cancelAnimationFrame(this.animationFrame)

    if (isNaN(index)) {
      index = this.currentSlide
    }
    this.currentSlide = index % this.slidesTotal
    this.currentSliderLeft = -this.slideOffset(index)

    this.animationFrame = requestAnimationFrame(() => {
      this.slider.style.left = `${this.currentSliderLeft}px`
      this.updateNavArrows()
    })
  }

  slideOffset(index) {
    if (index < this.slides.length) {
      const slide = this.slides[index]
      return slide.offsetLeft
    } else {
      return 0
    }
  }

  isLastSlideVisible(offset) {
    const sliderOffset = offset || this.currentSliderLeft

    const viewPortWidth = this.viewPort.offsetWidth
    const lastSlide = this.slides[this.slides.length - 1]

    if (lastSlide) {
      const lastSlideLeft = lastSlide.offsetLeft
      const lastSlideOuterWidth = lastSlide.offsetWidth
      return lastSlideLeft + lastSlideOuterWidth + sliderOffset < viewPortWidth
    } else {
      return true
    }
  }

  updateNavArrows() {
    if (this.currentSlide <= 0 || isNaN(this.currentSlide)) {
      this.prev.classList.add('disabled')
    } else {
      this.prev.classList.remove('disabled')
    }

    if (this.isLastSlideVisible()) {
      this.next.classList.add('disabled')
    } else {
      this.next.classList.remove('disabled')
    }
  }
}

window.SilverfinCarousel = SilverfinCarousel
